import { createContext, useContext, useState, useCallback } from "react";

const FormModalContext = createContext(null);

export function FormModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [preselect, setPreselect] = useState(null);

  const openForm = useCallback((pkg = null) => {
    setPreselect(pkg);
    setOpen(true);
  }, []);

  const closeForm = useCallback(() => setOpen(false), []);

  return (
    <FormModalContext.Provider value={{ open, setOpen, preselect, openForm, closeForm }}>
      {children}
    </FormModalContext.Provider>
  );
}

export function useFormModal() {
  const ctx = useContext(FormModalContext);
  if (!ctx) throw new Error("useFormModal must be used within FormModalProvider");
  return ctx;
}
